import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

import ContactView from '@/views/ContactView'
import TermsPage from '@/views/contact/TermsPage'

// 어바웃
import AboutView from '@/views/AboutView'
import AboutHistory from '@/views/about/AboutHistory'
import AboutMap from '@/views/about/AboutMap'
import AboutReferences from '@/views/about/AboutReferences'

// 서비스
import ServiceView from '@/views/ServiceView'
import ServiceDetailKeycloak from '@/views/service/ServiceDetailKeycloak'
import ServiceDetailAiData from '@/views/service/ServiceDetailAiData'
import ServiceDetailCloudConsulting from '@/views/service/ServiceDetailCloudConsulting'
import ServiceDetailMaintenance from '@/views/service/ServiceDetailMaintenance'

// 솔루션
import SolutionView from '@/views/SolutionView'
import SolutionDetailNsddh from '@/views/solution/SolutionDetailNsddh'
import SolutionDetailIAM from '@/views/solution/SolutionDetailIAM'
import SolutionDetailSSO from '@/views/solution/SolutionDetailSSO'
import SolutionDetailISIGN from '@/views/solution/SolutionDetailISIGN'
import SolutionDetailTwoFactor from '@/views/solution/SolutionDetailTwoFactor'

// 컨설팅
import ConsultingView from '@/views/ConsultingView'
import ConsultingDetailOperation from '@/views/consulting/ConsultingDetailOperation'
import ConsultingDetailClient from '@/views/consulting/ConsultingDetailClient'
import ConsultingDetailServer from '@/views/consulting/ConsultingDetailServer'
import ConsultingDetailMonitoring from '@/views/consulting/ConsultingDetailMonitoring'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // ──────────────────────────────
  // 어바웃
  // ──────────────────────────────
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/about/history',
    name: 'aboutHistory',
    component: AboutHistory
  },
  {
    path: '/about/map',
    name: 'aboutMap',
    component: AboutMap
  },
  {
    path: '/about/references',
    name: 'aboutReferences',
    component: AboutReferences
  },
  // ──────────────────────────────
  // 컨택트
  // ──────────────────────────────
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  {
    path: '/contact/terms',
    name: 'terms',
    component: TermsPage
  },

  // ──────────────────────────────
  // 서비스
  // ──────────────────────────────
  {
    path: '/service',
    name: 'service',
    component: ServiceView
  },
  {
    path: '/service/keycloak',
    name: 'serviceKeycloak',
    component: ServiceDetailKeycloak
  },
  {
    path: '/service/ai-data',
    name: 'serviceAiData',
    component: ServiceDetailAiData
  },
  {
    path: '/service/cloud-consulting',
    name: 'serviceCloudConsulting',
    component: ServiceDetailCloudConsulting
  },
  {
    path: '/service/maintenance',
    name: 'serviceMaintenance',
    component: ServiceDetailMaintenance
  },

  // ──────────────────────────────
  // 솔루션
  // ──────────────────────────────
  {
    path: '/solution',
    name: 'solution',
    component: SolutionView
  },
  {
    path: '/solution/nsddh',
    name: 'solutionNsddh',
    component: SolutionDetailNsddh
  },
  {
    path: '/solution/iam',
    name: 'solutionIAM',
    component: SolutionDetailIAM
  },
  {
    path: '/solution/sso',
    name: 'solutionSSO',
    component: SolutionDetailSSO
  },
  {
    path: '/solution/isign',
    name: 'solutionISIGN',
    component: SolutionDetailISIGN
  },
  {
    path: '/solution/two-factor',
    name: 'solutionTwoFactor',
    component: SolutionDetailTwoFactor
  },

  // ──────────────────────────────
  // 컨설팅
  // ──────────────────────────────
  {
    path: '/consulting',
    name: 'consulting',
    component: ConsultingView
  },
  {
    path: '/consulting/operation',
    name: 'consultingOperation',
    component: ConsultingDetailOperation
  },
  {
    path: '/consulting/client',
    name: 'consultingClient',
    component: ConsultingDetailClient
  },
  {
    path: '/consulting/server',
    name: 'consultingServer',
    component: ConsultingDetailServer
  },
  {
    path: '/consulting/monitoring',
    name: 'consultingMonitoring',
    component: ConsultingDetailMonitoring
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior () {
    return { top: 0 }
  }
})

export default router
